import React from "react";

function FileCheck03Icon({ fill, ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill={fill ?? ""}
      {...restProps}
    >
      <path
        d="M5.75.869c-.981.064-1.675.354-2.268.947-.432.432-.72.955-.85 1.545-.125.567-.137 1.251-.123 7.072.014 5.824.012 5.783.159 6.355.264 1.031 1.18 1.947 2.212 2.211.582.149.653.151 5.12.151 4.467 0 4.538-.002 5.12-.151 1.031-.263 1.948-1.18 2.211-2.208.153-.595.152-.586.152-5.591V6.45l-.078-.15c-.109-.21-5.162-5.262-5.372-5.372l-.15-.078L9.017.846C7.44.844 5.97.854 5.75.869m5.092 3.439c.014 1.97.013 1.958.212 2.33.122.229.413.519.641.641.373.2.361.198 2.331.212l1.81.013-.011 4.29c-.011 3.937-.017 4.307-.069 4.504-.151.56-.578.981-1.142 1.126-.215.055-.524.059-4.614.059-4.102 0-4.398-.003-4.616-.059a1.486 1.486 0 0 1-.71-.402 1.473 1.473 0 0 1-.431-.741c-.056-.217-.06-.594-.06-6.281 0-5.687.004-6.064.06-6.281.032-.127.102-.307.156-.4.189-.331.562-.629.901-.72.289-.078.67-.09 3.09-.094l2.439-.005.013 1.808m2.741.459 1.067 1.066H12.5V4.767c0-.587.004-1.067.009-1.067.004 0 .488.48 1.074 1.067m-1.016 5.736c-.114.051-.548.464-1.774 1.689l-1.624 1.621-.593-.583c-.335-.329-.651-.611-.726-.647-.175-.084-.52-.087-.687-.005-.419.205-.605.725-.4 1.122.106.205 1.832 1.931 2.037 2.037.194.1.522.107.717.015.205-.096 4.059-3.954 4.147-4.152a.85.85 0 0 0-.167-.931.847.847 0 0 0-.93-.166"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default FileCheck03Icon;
